import { render, staticRenderFns } from "./addKeyAdress.vue?vue&type=template&id=1270cba6&"
import script from "./addKeyAdress.vue?vue&type=script&lang=js&"
export * from "./addKeyAdress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports